module.exports = __webpack_public_path__ + "img/collapse-open.5c41be60.svg";